/* eslint-disable @typescript-eslint/no-require-imports */
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import Image from 'next/image';

import { useFallbackTranslation } from '../../utils/hooks';
import { isBlueparrottFromContext } from '../../utils/multisite/utils';

export const LogoLink = () => {
  const { getURLWithLocalePrefix, t } = useFallbackTranslation();
  const { sitecoreContext } = useSitecoreContext();
  const isBlueparrott = isBlueparrottFromContext(sitecoreContext);

  const logoSrc = isBlueparrott
    ? require('./images/blueparrott-logo.svg?url')
    : require('./images/jabra-logo.svg?url');
  const logoAlt = t(isBlueparrott ? 'topmenu.BlueParrottLogo' : 'topmenu.JabraLogo');

  return (
    <div className="flex items-center">
      <a
        href={getURLWithLocalePrefix('/')}
        className="mr-auto flex h-10 w-fit justify-start self-center text-xs"
      >
        {/* src specified with `require` to dynamically resolve svg path in next application */}
        <Image
          className="w-32"
          width="600"
          height="200"
          alt={logoAlt}
          src={logoSrc}
          aria-label={logoAlt}
        />
      </a>
    </div>
  );
};
